module.exports = __webpack_public_path__ + "img/congrats-banner.7b9fa5e.svg";